var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { toJS } from "mobx";
import { types, getParentOfType, getSnapshot, applySnapshot, onSnapshot as _onSnapshot } from "mobx-state-tree";
import { get, isNil, times } from "lodash-es";
import { generateId } from "../core/utils";
import { NODE_TYPES, CHART_TYPES } from "../core/common";
import { Store } from "./Store";

export var ChartModel = types.model("ChartModel", {
  id: types.optional(types.identifier, function () {
    return generateId();
  }),
  type: NODE_TYPES.chart,
  chartType: types.maybeNull(types.enumeration(Object.values(CHART_TYPES))),
  dataRefs: types.frozen(null)
}).volatile(function () {
  return {
    isMenuOpen: false
  };
}).views(function (self) {
  return {
    get store() {
      return getParentOfType(self, Store);
    },
    get data() {
      if (!self.dataRefs) {
        return null;
      }

      var _self$dataRefs = self.dataRefs,
          _self$dataRefs$xAxis = _self$dataRefs.xAxis,
          xAxis = _self$dataRefs$xAxis === undefined ? [] : _self$dataRefs$xAxis,
          _self$dataRefs$series = _self$dataRefs.series,
          series = _self$dataRefs$series === undefined ? [] : _self$dataRefs$series;


      if (series.length === 0) {
        return null;
      }

      var _series = series.map(function (path) {
        return self.store.getData(path);
      });

      if (_series.some(isNil)) {
        return null;
      }

      var _xAxis = self.store.getData(xAxis);
      if (!_xAxis) {
        var seriesMaxLength = Math.max.apply(Math, _series.map(function (s) {
          return get(s, "data.length") || 0;
        }));
        _xAxis = {
          id: null,
          name: null,
          data: times(seriesMaxLength)
        };
      }

      return {
        xAxis: _xAxis,
        series: _series
      };
    },
    serialize: function serialize() {
      var toJSON = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      return toJSON ? getSnapshot(self) : toJS(self);
    },
    onSnapshot: function onSnapshot(callback) {
      return _onSnapshot(self, callback);
    }
  };
}).actions(function (self) {
  return {
    toggleMenuOpen: function toggleMenuOpen() {
      var isMenuOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !self.isMenuOpen;

      self.isMenuOpen = isMenuOpen;
    },
    setDataRefs: function setDataRefs(dataRefs) {
      self.dataRefs = dataRefs;
    },
    destroy: function destroy() {
      self.store.removeNode(self);
    },
    setProps: function setProps(props) {
      if (!props) return;

      applySnapshot(self, _extends({}, self.serialize(), props));
    }
  };
});